import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-init-loader',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './init-loader.component.html',
  styleUrls: ['./init-loader.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-init-loader' }
})
export class InitLoaderComponent {

}
